/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Language_Not_Supported_TitleInputs */

const en_dialog_text_to_audio_language_not_supported_title = /** @type {(inputs: Dialog_Text_To_Audio_Language_Not_Supported_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language not supported`)
};

const es_dialog_text_to_audio_language_not_supported_title = /** @type {(inputs: Dialog_Text_To_Audio_Language_Not_Supported_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma no compatible`)
};

/**
* | output |
* | --- |
* | "Language not supported" |
*
* @param {Dialog_Text_To_Audio_Language_Not_Supported_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_language_not_supported_title = /** @type {((inputs?: Dialog_Text_To_Audio_Language_Not_Supported_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Language_Not_Supported_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_language_not_supported_title(inputs)
	return en_dialog_text_to_audio_language_not_supported_title(inputs)
});